import queryHttp from './queryHttp';

const getQueries = (context, tags) => {
  return new Promise((resolve, reject) => {
    queryHttp.getQueries(context, tags)
      .then(response => {
        const list = addOrderInQueryList(response.body);
        resolve(list);
      }, error => {
        reject(error);
      });
  });
};

const createQuery = (context, query) => {
  return new Promise((resolve, reject) => {
    queryHttp.createQuery(context, query)
      .then(response => {
        const query = addOrderInQuery(response.body);
        resolve(query);
      }, error => {
        reject(error);
      });
  });
};

const updateQuery = (context, query) => {
  return new Promise((resolve, reject) => {
    queryHttp.updateQuery(context, query)
      .then(response => {
        const query = addOrderInQuery(response.body);
        resolve(query);
      }, error => {
        reject(error);
      });
  });
};

const deleteQuery = (context, id) => {
  return new Promise((resolve, reject) => {
    queryHttp.deleteQuery(context, id)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const addOrderInQuery = (query) => {
  if (query !== undefined) {
    query.order = (query.star ? 'a' : 'z') + query.name;
  }
  return query;
};

const addOrderInQueryList = (list) => {
  const newList = [];
  for (let query of list) {
    const newQuery = addOrderInQuery(query);
    if (newQuery !== undefined) {
      newList.push(newQuery);
    }
  }
  return newList;
};

const getPermissionsByUser = (context, queryId) => {
  return new Promise((resolve, reject) => {
    queryHttp.getPermissionsByUser(context, queryId)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getPermissionsByGroup = (context, queryId) => {
  return new Promise((resolve, reject) => {
    queryHttp.getPermissionsByGroup(context, queryId)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const addPermission = (context, permissionType, queryId, userOrGroup, userOrGroupId) => {
  return new Promise((resolve, reject) => {
    queryHttp.addPermission(context, permissionType, queryId, userOrGroup, userOrGroupId)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const deletePermission = (context, permissionType, queryId, userOrGroup, userOrGroupId) => {
  return new Promise((resolve, reject) => {
    queryHttp.deletePermission(context, permissionType, queryId, userOrGroup, userOrGroupId)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

export default {
  getQueries,
  createQuery,
  updateQuery,
  deleteQuery,
  getPermissionsByUser,
  getPermissionsByGroup,
  addPermission,
  deletePermission
};



// WEBPACK FOOTER //
// ./src/api/query/index.js